import React from 'react';
import InventoryTransactions from 'components/app/erp/InventoryTransactions';

// Route-level page entry for ERP Inventory Transactions.
const InventoryTransactionPage = () => <InventoryTransactions />;

export default InventoryTransactionPage;
